import SolicitarAtendimentoFavorito from '../components/SolicitarAtendimentoFavorito.vue'

let routes = {
    path: '/sobre',
    component: resolve => require(['../components/layout/HeaderAndLeftNavBar.vue'], resolve),
    children: [
        {
            path: '/solicitar-atendimento-favorito',
            name: 'SolicitarAtendimentoFavorito',
            component: SolicitarAtendimentoFavorito
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/solicitar_atendimento_favorito.js